import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  editorialSummary: string
  lineClamp?: number
  variant?: 'small' | 'medium' | 'large'
}

function GoogleEditorialSummary({ editorialSummary, lineClamp, variant = 'medium' }: Props) {
  return (
    <BodyText variant={variant} weight="normal" lineClamp={lineClamp}>
      {editorialSummary}
    </BodyText>
  )
}

export default GoogleEditorialSummary
